export enum ConfirmMessages {
  SaveAndContinue = '+k1e',
  DiscardUnsavedChanges = 'rpRb',
  LeaveWithUnsavedChanges = 'Gc0C',
  AcceptEntity = 'UD/V',
  SubmitEntity = 'fFq+',
  CancelEntity = 'OqEf',
  AreYouWantToBulkUpdateHowManyTarget = 'ZFlh',
  AreYouWantToBulkUpdateTarget = 'XxNF',
  CanNotChangeAfterSubmitted = 'HrBc',
  RejectEntireOrder = 'l8Jl',
  RejectEntireEntity = 'DkoU',
  SaveAndProcessUnsavedChanges = '9OBT',
  SaveInventoryCountConfirmationMessage = 'I4v6',
  UnsavedCountErrorWithEntityName = 'bwsT',
  UnsavedCountErrorWithFormName = 'DEvn',
  ConfirmCompleteCount = 'Vfig',
  AreYouSureYouWantToRemoveItem = 'Qml7',
  AreYouSureYouWantToRemoveSiteCount = 'riVp',
  AreYouSureYouWantToRemoveSelectedSiteCounts = 'Qqxa',
  AreYouSureYouWantToClearAllCount = 'RI9y',
  HaveUnsavedChangesAreYouSureYouWantToExit = '99V8',
  ConfirmActionToEntity = 'PcbV',
  ConfirmBeforeExiting = '5luC',
  ConfirmCancelAllOpenStandWorksheets = 'DPb9',

  RemoveListViewConfirmMessage = 'IJoB',
}
